import _cloneDeep from "lodash/cloneDeep";

export const color_items = {
  data: function(){
    return {
      color_items: {
        row: [
          "select_cell",
          "select_row",
          "modified",
          "select_term",
          "not_found_term"
        ],
        status: [
          // "editing_*",
          "editing",
          "editing_perfect_matched",
          "locked",
          "deleted",
          "commented"
        ],
        text: [
          "normal",
          "searched",
          "term"
        ]
      }
    };
  },
  methods: {
    default_colors: function(){
      return {
        // row
        select_cell: {
          border_color: "#7BBC16FF",
          border_style: "bold_solid",
          background_color: "#FFFFFFFF"
        },
        select_row: {
          border_color: "#0000001F",
          border_style: "solid",
          background_color: "#FFFACDFF"
        },
        modified: {
          border_color: "#FFA500FF",
          border_style: "bold_dashed",
          background_color: "#FFFFFFFF"
        },
        select_term: {
          border_color: "#1565C0FF",
          border_style: "solid",
          background_color: "#E0F7FAFF"
        },
        not_found_term: {
          border_color: "#1565C0FF",
          border_style: "bold_dashed",
          background_color: "#FFFFFFFF"
        },
        // status
        editing: {
          border_color: "#0000001F",
          border_style: "solid",
          background_color: "#FFFFFFFF"
        },
        editing_perfect_matched: {
          border_color: "#0000001F",
          border_style: "solid",
          background_color: "#E8F5E9FF"
        },
        locked: {
          border_color: "#0000001F",
          border_style: "solid",
          background_color: "#EEEEEEFF"
        },
        deleted: {
          border_color: "#0000001F",
          border_style: "solid",
          background_color: "#EEEEEEFF"
        },
        commented: {
          border_color: "#0000001F",
          border_style: "solid",
          background_color: "#EEEEEEFF"
        },
        // text
        normal: {
          bold: false,
          color: "#000000FF"
        },
        searched: {
          bold: true,
          color: "#FF0000FF"
        },
        term: {
          bold: true,
          color: "#1565C0FF"
        }
      };
    },
    get_color: function(type, name){
      var colors = this.preference_colors();
      var color = _cloneDeep(colors[name]);
      return color;
    },
    preference_colors: function(){
      if(this.$store.getters.preference
        && this.$store.getters.preference.editor
        && this.$store.getters.preference.editor.colors){
        return this.$store.getters.preference.editor.colors;
      }else{
        return this.default_colors();
      }
    }
  }
}
